import type { FactoriesTranslations } from './types';

/**
 * Urdu translations for Factories domain
 */
export const urTranslations: FactoriesTranslations = {
  // Page/Section level
  title: 'فیکٹریاں',
  subtitle: 'مینوفیکچرنگ پلانٹس اور پیداواری سہولیات کا انتظام کریں',

  // Actions
  addFactory: 'فیکٹری شامل کریں',
  editFactory: 'فیکٹری میں ترمیم کریں',
  deleteFactory: 'فیکٹری حذف کریں',
  factoryDetails: 'فیکٹری کی تفصیلات',

  // Search and states
  searchPlaceholder: 'فیکٹریاں تلاش کریں...',
  filterByStatus: 'حالت کے مطابق فلٹر کریں',
  noFactories: 'کوئی فیکٹری نہیں ملی',
  noFactoriesDescription:
    'آپ نے ابھی تک کوئی فیکٹری شامل نہیں کی۔ شروع کرنے کے لیے اپنی پہلی فیکٹری شامل کریں۔',
  addFirst: 'اپنی پہلی فیکٹری شامل کریں',
  totalFactories: 'کل فیکٹریاں',

  // Form fields
  form: {
    factory: 'فیکٹری',
    selectFactory: 'فیکٹری منتخب کریں',
    code: 'فیکٹری کوڈ',
    codePlaceholder: 'فیکٹری کوڈ درج کریں (مثال: FAC-001)',
    sapPlantCode: 'SAP پلانٹ کوڈ',
    sapPlantCodePlaceholder: 'SAP پلانٹ کوڈ درج کریں (مثال: 1000)',
    nameEn: 'فیکٹری کا نام (انگریزی)',
    nameEnPlaceholder: 'انگریزی میں فیکٹری کا نام درج کریں',
    nameAr: 'فیکٹری کا نام (عربی)',
    nameArPlaceholder: 'عربی میں فیکٹری کا نام درج کریں',
    address: 'پتہ',
    addressPlaceholder: 'گلی کا پتہ درج کریں',
    city: 'شہر',
    selectCity: 'شہر منتخب کریں',
    country: 'ملک',
    selectCountry: 'ملک منتخب کریں',
    postalCode: 'پوسٹل کوڈ',
    timezone: 'ٹائم زون',
    coordinates: 'نقاط',
    status: 'حالت',
  },

  // Validation
  validation: {
    codeRequired: 'فیکٹری کوڈ درکار ہے',
    nameRequired: 'فیکٹری کا نام درکار ہے',
    countryRequired: 'ملک درکار ہے',
  },

  // Status
  status: {
    active: 'فعال',
    inactive: 'غیر فعال',
  },

  // Messages
  messages: {
    createSuccess: 'فیکٹری کامیابی سے بنائی گئی',
    updateSuccess: 'فیکٹری کامیابی سے اپ ڈیٹ ہوئی',
    deleteSuccess: 'فیکٹری کامیابی سے حذف ہوئی',
    deleteConfirm: 'کیا آپ واقعی اس فیکٹری کو حذف کرنا چاہتے ہیں؟',
  },

  // Card display
  card: {
    noAddress: 'کوئی پتہ نہیں',
    noCity: 'کوئی شہر نہیں',
    noCountry: 'کوئی ملک نہیں',
    locationNotSet: 'مقام سیٹ نہیں ہے',
    created: 'بنایا گیا',
    updated: 'اپ ڈیٹ کیا گیا',
  },

  // Top-level convenience keys (flat versions for direct access)
  code: 'فیکٹری کوڈ',
  codePlaceholder: 'فیکٹری کوڈ درج کریں (مثال: FAC-001)',
  sapPlantCode: 'SAP پلانٹ کوڈ',
  sapPlantCodePlaceholder: 'SAP پلانٹ کوڈ درج کریں (مثال: 1000)',
  nameEn: 'فیکٹری کا نام (انگریزی)',
  nameEnPlaceholder: 'انگریزی میں فیکٹری کا نام درج کریں',
  nameAr: 'فیکٹری کا نام (عربی)',
  nameArPlaceholder: 'عربی میں فیکٹری کا نام درج کریں',
  address: 'پتہ',
  addressPlaceholder: 'گلی کا پتہ درج کریں',
  city: 'شہر',
  selectCity: 'شہر منتخب کریں',
  country: 'ملک',
  selectCountry: 'ملک منتخب کریں',
  postalCode: 'پوسٹل کوڈ',
  timezone: 'ٹائم زون',
  coordinates: 'نقاط',
  statusLabel: 'حالت',
  codeRequired: 'فیکٹری کوڈ درکار ہے',
  nameRequired: 'فیکٹری کا نام درکار ہے',
  countryRequired: 'ملک درکار ہے',
  active: 'فعال',
  inactive: 'غیر فعال',
  createSuccess: 'فیکٹری کامیابی سے بنائی گئی',
  updateSuccess: 'فیکٹری کامیابی سے اپ ڈیٹ ہوئی',
  deleteSuccess: 'فیکٹری کامیابی سے حذف ہوئی',
  deleteConfirm: 'کیا آپ واقعی اس فیکٹری کو حذف کرنا چاہتے ہیں؟',
  noAddress: 'کوئی پتہ نہیں',
  noCity: 'کوئی شہر نہیں',
  noCountry: 'کوئی ملک نہیں',
  locationNotSet: 'مقام سیٹ نہیں ہے',
  created: 'بنایا گیا',
  updated: 'اپ ڈیٹ کیا گیا',
  addDescription: 'ایک نئی مینوفیکچرنگ سہولت شامل کریں',
  editDescription: 'فیکٹری کی تفصیلات اپ ڈیٹ کریں',
  basicInfo: 'بنیادی معلومات',
  selectStatus: 'حالت منتخب کریں',
  locationInfo: 'مقام',
  selectLocation: 'مقام منتخب کریں',
  noLocationOption: 'کوئی نہیں',
  locationHint: 'ایڈریس بک سے موجود مقام منتخب کریں یا خالی چھوڑ دیں',
  citiesServed: 'سروس دی جانے والی شہر',
  citiesServedHint: 'ان شہروں کو منتخب کریں جہاں یہ فیکٹری ڈیلیوری کر سکتی ہے',
  searchCities: 'شہر تلاش کریں...',
  noCitiesMatch: 'آپ کی تلاش سے کوئی شہر نہیں ملا',
  noCitiesAvailable: 'کوئی شہر دستیاب نہیں',
  selectedCityCount: '{{count}} شہر منتخب کیے گئے',
  selected: 'منتخب',
  loadMoreCities: 'مزید شہر لوڈ کریں',
  descriptionSection: 'تفصیل',
  descriptionEn: 'تفصیل (انگریزی)',
  descriptionAr: 'تفصیل (عربی)',
  descriptionPlaceholder: 'فیکٹری کی تفصیل درج کریں',
  descriptionArPlaceholder: 'فیکٹری کی عربی تفصیل درج کریں',
  saving: 'محفوظ کیا جا رہا ہے...',
  deleting: 'حذف کیا جا رہا ہے...',
  close: 'بند کریں',
};
